<script setup lang="ts"></script>

<template>
   <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="7.30103" cy="8" r="7.3042" fill="white" />
      <path d="M4.64734 8.17084L6.79345 10.3253L10.5963 5.6928" stroke="#A2A2A2" stroke-width="1.5"
         stroke-linecap="round" stroke-linejoin="round" />
   </svg>
</template>

<style scoped></style>